/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Change_Not_FoundInputs */

const en_us2_plan_change_not_found = /** @type {(inputs: Plan_Change_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That change is no longer in the draft. Reload it and try again.`)
};

const pt_br2_plan_change_not_found = /** @type {(inputs: Plan_Change_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essa mudança não está mais no rascunho. Recarregue e tente de novo.`)
};

const es_419_plan_change_not_found = /** @type {(inputs: Plan_Change_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ese cambio ya no está en el borrador. Recárgalo e inténtalo de nuevo.`)
};

const pt_pt2_plan_change_not_found = /** @type {(inputs: Plan_Change_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essa alteração já não está no rascunho. Recarrega-o e tenta de novo.`)
};

const fr_fr2_plan_change_not_found = /** @type {(inputs: Plan_Change_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette modification n'est plus dans le brouillon. Recharge-le et réessaie.`)
};

const de_de2_plan_change_not_found = /** @type {(inputs: Plan_Change_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Änderung ist nicht mehr im Entwurf. Lade ihn neu und versuch es erneut.`)
};

const it_it2_plan_change_not_found = /** @type {(inputs: Plan_Change_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questa modifica non è più nella bozza. Ricaricala e riprova.`)
};

/**
* | output |
* | --- |
* | "That change is no longer in the draft. Reload it and try again." |
*
* @param {Plan_Change_Not_FoundInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_change_not_found = /** @type {((inputs?: Plan_Change_Not_FoundInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Change_Not_FoundInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_change_not_found(inputs)
	if (locale === "es-419") return es_419_plan_change_not_found(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_change_not_found(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_change_not_found(inputs)
	if (locale === "de-DE") return de_de2_plan_change_not_found(inputs)
	if (locale === "it-IT") return it_it2_plan_change_not_found(inputs)
	return en_us2_plan_change_not_found(inputs)
});
export { plan_change_not_found as "plan.change_not_found" }